// 首页
import request from '@/utils/request'

// 设备总数量、当前异常数、设备类型占比、当前异常--柱状图
export function findCompanyDeviceStatistic(params) {
  return request({
    url: '/v3/report/findCompanyDeviceStatistic',
    method: 'post',
    data: params
  })
}
export function deviceOnlineStatistic(params) { // 设备联网率
  return request({
    url: 'v3/report/deviceOnlineStatistic',
    method: 'post',
    data: params
  })
}
// 当前异常--柱状图
// export function findWarningByFunction(params) {
//   return request({
//     url: '/v3/report/findWarningByFunction',
//     method: 'post',
//     data: params
//   })
// }
// 获取前10条警告信息
export function listWarningByCompany(params) {
  return request({
    url: '/v3/report/listWarningByCompany',
    method: 'post',
    data: params
  })
}

// 设备基本信息
export function findDeviceInfo(params) {
  return request({
    url: '/v3/report/findDeviceInfo',
    method: 'post',
    data: params
  })
}
// 首页获取公司城市/站点警告统计数据
export function mainWarningStatisticData(params) {
  return request({
    url: '/v3/report/mainWarningStatisticData',
    method: 'post',
    data: params
  })
}
// 首页获取公司城市/站点警告统计数据--分页
export function mainSiteWarningStatisticData(params) {
  return request({
    url: '/v3/report/mainSiteWarningStatisticData',
    method: 'post',
    data: params
  })
}
// 首页获取公司警告统计数据--分页
export function mainCompanyWarningStatisticData(params) {
  return request({
    url: '/v3/report/mainCompanyWarningStatisticData',
    method: 'post',
    data: params
  })
}
